import { render, staticRenderFns } from "./springFDataStatistic.vue?vue&type=template&id=e1e2c00e&scoped=true"
import script from "./springFDataStatistic.vue?vue&type=script&lang=ts"
export * from "./springFDataStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e2c00e",
  null
  
)

export default component.exports